module.exports = __webpack_public_path__ + "static/media/information.1c0435f4.svg";